import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import logo from '../../logo.png';
import {
  Settings, Plus, Edit2, Trash2, X, Search, Lock, Users, ArrowUpCircle,
  Camera, Loader, ArrowUp, ArrowDown, Check, Map, UserCheck, Flag,
  ClipboardList, Package, BarChart2, ChevronLeft, Home
} from 'lucide-react';

const MODULOS = [
  { key: 'usuarios',    label: 'Usuarios',             emoji: '👥', color: 'bg-blue-600',    desc: 'Alta, baja y permisos' },
  { key: 'casillas',    label: 'Casillas Electorales', emoji: '🗳️', color: 'bg-red-600',     desc: 'Representantes y asignaciones' },
  { key: 'promovidos',  label: 'Promovidos',           emoji: '📋', color: 'bg-green-600',   desc: 'Padrón de promovidos' },
  { key: 'org',         label: 'Estructuras y Miembros',emoji: '🏗️', color: 'bg-orange-500',  desc: 'Estructuras, cargos y miembros' },
  { key: 'secciones',   label: 'Secciones Electorales',emoji: '📍', color: 'bg-purple-600',  desc: 'Secciones y colonias' },
  { key: 'grupos',      label: 'Grupos Políticos',     emoji: '🎯', color: 'bg-indigo-600',  desc: 'Partidos y coaliciones' },
  { key: 'programas',   label: 'Programas Sociales',   emoji: '🤝', color: 'bg-pink-600',    desc: 'Catálogo de programas' },
  { key: 'evidencias',  label: 'Tipos de Evidencia',   emoji: '📸', color: 'bg-yellow-600',  desc: 'Tipos de material' },
  { key: 'participacion', label: 'Tipos de Participación', emoji: '🤝', color: 'bg-purple-600', desc: 'Tipos de participación política' },
];

export default function Admin() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [modulo, setModulo] = useState(null); // null = dashboard
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState(null);

  // ── Datos globales ──
  const [secciones, setSecciones] = useState([]);
  const [estructuras, setEstructuras] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);
  const [promovidos, setPromovidos] = useState([]);
  const [miembros, setMiembros] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [catalogosMiembros, setCatalogosMiembros] = useState({ cargos:[], grupos:[], secciones:[], sectores:[], miembros_para_lider:[], estructuras:[] });
  const [tiposEvidencia, setTiposEvidencia] = useState([]);
  const [tiposParticipacion, setTiposParticipacion] = useState([]);
  const [formNuevoParticipacion, setFormNuevoParticipacion] = useState({ nombre:'', clave:'' });
  const [mostrarNuevoParticipacion, setMostrarNuevoParticipacion] = useState(false);
  const [programas, setProgramas] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);

  // ── Forms ──
  const [formSeccion, setFormSeccion] = useState({ numero_seccion:'', municipio:'', localidad:'', meta_votos:0, colonias:[] });
  const [nuevaColonia, setNuevaColonia] = useState('');
  const [formEstructura, setFormEstructura] = useState({ nombre_estructura:'', tipo_estructura:'', grupo_politico_id:'', seccion_id:'', sector_id:'' });
  const [formGrupo, setFormGrupo] = useState({ nombre_grupo:'', descripcion:'' });
  const [mostrarFormGrupo, setMostrarFormGrupo] = useState(false);
  const [editandoGrupo, setEditandoGrupo] = useState(null);
  const [formPrograma, setFormPrograma] = useState({ clave:'', etiqueta:'', emoji:'🏛️', orden:0 });
  const [mostrarFormPrograma, setMostrarFormPrograma] = useState(false);
  const [editandoPrograma, setEditandoPrograma] = useState(null);
  const [formNuevoTipo, setFormNuevoTipo] = useState({ clave:'', etiqueta:'', emoji:'📦', color:'#64748b' });
  const [mostrarNuevoTipo, setMostrarNuevoTipo] = useState(false);
  const [editandoTipo, setEditandoTipo] = useState(null);
  const [editandoParticipacion, setEditandoParticipacion] = useState(null);
  const [formEditParticipacion, setFormEditParticipacion] = useState({ nombre:'', clave:'' });
  const [formEditTipo, setFormEditTipo] = useState({ etiqueta:'', emoji:'', color:'' });

  // Modales miembros
  const [mostrarModalEditarMiembro, setMostrarModalEditarMiembro] = useState(false);
  const [pestanaOrg, setPestanaOrg] = useState('estructuras'); // 'estructuras' | 'miembros'
  const [mostrarFormMiembro, setMostrarFormMiembro] = useState(false);
  const [formNuevoMiembro, setFormNuevoMiembro] = useState({
    nombre:'', apellido_paterno:'', apellido_materno:'', telefono:'',
    ocupacion_general:'', nivel_estudios:'', estructura_id:'', cargo_id:'',
    seccion_id:'', sector_id:'', grupo_politico_id:'', lider_inmediato_id:'',
    fecha_inicio:'', observaciones:''
  });
  const [resultadoNuevoMiembro, setResultadoNuevoMiembro] = useState(null);
  const [guardandoMiembro, setGuardandoMiembro] = useState(false);
  const [miembroEditando, setMiembroEditando] = useState(null);
  const [formEditarMiembro, setFormEditarMiembro] = useState({ estructura_id:'', cargo_id:'', seccion_id:'', sector_id:'', grupo_politico_id:'', lider_inmediato_id:'', fecha_inicio:'', observaciones:'' });

  // Modal promover
  const [mostrarModalPromover, setMostrarModalPromover] = useState(false);
  const [mostrarModalEditarPromovido, setMostrarModalEditarPromovido] = useState(false);
  const [promovidoEditando, setPromovidoEditando] = useState(null);
  const [formEditarPromovido, setFormEditarPromovido] = useState({
    nombre:'', apellido_paterno:'', apellido_materno:'', telefono_principal:'',
    telefono_alterno:'', clave_elector:'', domicilio_breve:'', calle:'',
    numero_exterior:'', colonia:'', codigo_postal:'', seccion_id:'',
    estructura_id_ganadora:'', nivel_apoyo:'seguro', ocupacion_general:'', observaciones:''
  });
  const [promovidoAPromover, setPromovidoAPromover] = useState(null);
  const [rolSeleccionado, setRolSeleccionado] = useState('');
  const [estructuraPromover, setEstructuraPromover] = useState('');
  const [liderPromover, setLiderPromover] = useState('');
  const [seccionPromover, setSeccionPromover] = useState('');
  const [resultadoPromover, setResultadoPromover] = useState(null);
  const [promoviendoRol, setPromoviendoRol] = useState(false);

  const esSuperadmin = user?.rol === 'superadmin' || user?.rol_nombre === 'superadmin';

  const mostrarMensaje = (tipo, texto) => {
    setMensaje({ tipo, texto });
    setTimeout(() => setMensaje(null), 3000);
  };

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [estRes, usRes, rolRes, secRes, perRes, mRes, catMRes] = await Promise.all([
        api.get('/estructuras'),
        api.get('/auth/usuarios'),
        api.get('/auth/roles'),
        api.get('/estructuras/catalogos'),
        api.get('/capturas/personas'),
        api.get('/miembros'),
        api.get('/miembros/catalogos')
      ]);
      setSecciones(secRes.data.secciones || []);
      setEstructuras(estRes.data.estructuras || []);
      setUsuarios((usRes.data.usuarios || []).filter(u => u.estatus === 'activo'));
      setRoles(rolRes.data.roles || []);
      setPromovidos(perRes.data.personas || []);
      setMiembros(mRes.data.miembros || []);
      setCatalogosMiembros(catMRes.data);
      try { const gRes = await api.get('/estructuras/grupos'); setGrupos(gRes.data.grupos || []); } catch(e) {}
      try { const tRes = await api.get('/catalogos/tipos-evidencia'); setTiposEvidencia(tRes.data.tipos || []); } catch(e) {}
      try { const pRes = await api.get('/catalogos/tipos-participacion'); setTiposParticipacion(pRes.data.tipos || []); } catch(e) {}
      try { const pRes = await api.get('/catalogos/programas-sociales'); setProgramas(pRes.data.programas || []); } catch(e) {}
    } catch (error) { console.error('Error:', error); }
    finally { setLoading(false); }
  };

  // ── Secciones ──
  const handleGuardarSeccion = async (e) => {
    e.preventDefault();
    try {
      if (editando?.id) { await api.put(`/estructuras/secciones/${editando.id}`, formSeccion); mostrarMensaje('exito','Sección actualizada.'); }
      else { await api.post('/estructuras/secciones', formSeccion); mostrarMensaje('exito','Sección creada.'); }
      setFormSeccion({ numero_seccion:'', municipio:'', localidad:'', meta_votos:0, colonias:[] });
      setMostrarForm(false); setEditando(null);
      setTimeout(() => fetchData(), 500);
    } catch(e) { mostrarMensaje('error', e.response?.data?.error || 'Error al guardar.'); }
  };
  const handleEliminarSeccion = async (id) => {
    if (!window.confirm('¿Eliminar esta sección?')) return;
    try { await api.delete(`/estructuras/secciones/${id}`); mostrarMensaje('exito','Sección eliminada.'); fetchData(); }
    catch(e) { mostrarMensaje('error','Error al eliminar.'); }
  };

  // ── Estructuras ──
  const handleGuardarEstructura = async (e) => {
    e.preventDefault();
    if (!esSuperadmin) return;
    try {
      if (editando?.id) { await api.put(`/estructuras/${editando.id}`, formEstructura); mostrarMensaje('exito','Estructura actualizada.'); }
      else { await api.post('/estructuras', formEstructura); mostrarMensaje('exito','Estructura creada.'); }
      setFormEstructura({ nombre_estructura:'', tipo_estructura:'', grupo_politico_id:'', seccion_id:'', sector_id:'' });
      setMostrarForm(false); setEditando(null);
      setTimeout(() => fetchData(), 500);
    } catch(e) { mostrarMensaje('error', e.response?.data?.error || 'Error al guardar.'); }
  };
  const handleEliminarEstructura = async (id) => {
    if (!esSuperadmin || !window.confirm('¿Eliminar esta estructura?')) return;
    try { await api.delete(`/estructuras/${id}`); mostrarMensaje('exito','Estructura eliminada.'); fetchData(); }
    catch(e) { mostrarMensaje('error','Error al eliminar.'); }
  };

  // ── Usuarios ──
  const abrirModalUsuario = (usuario) => { navigate(`/usuarios?editar=${usuario.id}&desde=admin`); };

  // ── Promovidos ──
  const getNivelColor = (nivel) => {
    const c = { seguro:'bg-green-100 text-green-800', probable:'bg-blue-100 text-blue-800', indeciso:'bg-yellow-100 text-yellow-800', oposicion:'bg-red-100 text-red-800' };
    return c[nivel] || 'bg-gray-100 text-gray-800';
  };
  const formatearPrograma = (clave) => {
    const encontrado = programas.find(pr => pr.clave === clave);
    if (encontrado) return encontrado.etiqueta;
    return String(clave||'').replace(/_/g,' ').replace(/\b\w/g, c => c.toUpperCase());
  };
  const abrirEditarPromovido = async (p) => {
    // Obtener datos frescos de la BD
    let datosPersona = p;
    try {
      const r = await api.get('/capturas/personas/' + (p.id || p.persona_id));
      if (r.data?.persona) {
        datosPersona = {...p, ...r.data.persona};
        // Agregar datos de captura y ultima visita
        if (r.data.capturas && r.data.capturas.length > 0) {
          // Usar estructura_id_ganadora de promovidos_activos si existe, sino la de capturas
          datosPersona.estructura_id = r.data.persona.estructura_id_ganadora || r.data.capturas[0].estructura_id;
          datosPersona.nombre_estructura = r.data.capturas[0].nombre_estructura;
        }
        if (r.data.ultima_visita) {
          datosPersona.resultado_visita = r.data.ultima_visita.resultado_visita;
        }
      }
    } catch(e) {}
    console.log('DATOS PERSONA:', datosPersona);
    setPromovidoEditando(datosPersona);
    setFormEditarPromovido({
      nombre: datosPersona.nombre || '',
      apellido_paterno: datosPersona.apellido_paterno || '',
      apellido_materno: datosPersona.apellido_materno || '',
      telefono_principal: datosPersona.telefono_principal || '',
      telefono_alterno: datosPersona.telefono_alterno || '',
      clave_elector: datosPersona.clave_elector || '',
      domicilio_breve: datosPersona.domicilio_breve || '',
      calle: datosPersona.calle || '',
      numero_exterior: datosPersona.numero_exterior || '',
      colonia: datosPersona.colonia || '',
      codigo_postal: datosPersona.codigo_postal || '',
      seccion_id: datosPersona.seccion_id || '',
      estructura_id_ganadora: datosPersona.estructura_id_ganadora || '',
      nivel_apoyo: datosPersona.nivel_apoyo || 'simpatizante',
      ocupacion_general: datosPersona.ocupacion_general || '',
      disponibilidad_servir: datosPersona.disponibilidad_servir || '',
      tipo_participacion_interes: datosPersona.tipo_participacion_interes || '',
      area_interes: datosPersona.area_interes || '',
      nivel_estudios: datosPersona.nivel_estudios || '',
      es_talento_potencial: datosPersona.es_talento_potencial || false,
      referencias: datosPersona.referencias || '',
      estructura_id: datosPersona.estructura_id_ganadora || datosPersona.estructura_id || '',
      resultado_visita: datosPersona.resultado_visita || '',
      latitud: datosPersona.latitud || '',
      longitud: datosPersona.longitud || '',
      es_beneficiario_programa: datosPersona.es_beneficiario_programa || false,
      programas_sociales: datosPersona.programas_sociales || [],
      observaciones: datosPersona.observaciones || ''
    });
    setMostrarModalEditarPromovido(true);
  };

  const handleGuardarEditarPromovido = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        ...formEditarPromovido,
        estructura_id_ganadora: formEditarPromovido.estructura_id
      };
      await api.put(`/capturas/personas/${promovidoEditando.persona_id || promovidoEditando.id}`, dataToSend);
      mostrarMensaje('exito', 'Promovido actualizado correctamente.');
      setMostrarModalEditarPromovido(false);
      fetchData();
    } catch(e) { mostrarMensaje('error', e.response?.data?.error || 'Error al actualizar.'); }
  };

  const handleEliminarPromovido = async (p) => {
    if (!window.confirm(`¿Eliminar a ${p.nombre} ${p.apellido_paterno} del padrón de promovidos?`)) return;
    try {
      await api.delete(`/capturas/personas/${p.persona_id || p.id}/eliminar`);
      mostrarMensaje('exito', 'Promovido eliminado correctamente.');
      fetchData();
    } catch(e) { mostrarMensaje('error', e.response?.data?.error || 'Error al eliminar.'); }
  };

  const abrirModalPromover = (p) => { setPromovidoAPromover(p); setRolSeleccionado(''); setEstructuraPromover(''); setLiderPromover(''); setSeccionPromover(''); setResultadoPromover(null); setMostrarModalPromover(true); };
  const handlePromoverRol = async () => {
    if (!rolSeleccionado) { mostrarMensaje('error','Selecciona un rol.'); return; }
    setPromoviendoRol(true);
    try {
      const r = await api.post('/auth/usuarios', { nombre: promovidoAPromover.nombre, apellido_paterno: promovidoAPromover.apellido_paterno, apellido_materno: promovidoAPromover.apellido_materno, telefono: promovidoAPromover.telefono_principal, password: promovidoAPromover.telefono_principal.slice(-4) + '!Dom', rol_id: rolSeleccionado, estructura_id: estructuraPromover || null, lider_inmediato_id: liderPromover || null, seccion_id: seccionPromover || null });
      setResultadoPromover({ exito: true, mensaje: `✅ Usuario creado. Contraseña temporal: ${promovidoAPromover.telefono_principal.slice(-4)}!Dom` });
      fetchData();
    } catch(e) { setResultadoPromover({ exito:false, mensaje: e.response?.data?.error || 'Error al promover.' }); }
    finally { setPromoviendoRol(false); }
  };

  // ── Miembros ──
  const handleCrearMiembro = async (e) => {
    e.preventDefault();
    setGuardandoMiembro(true);
    setResultadoNuevoMiembro(null);
    try {
      const r = await api.post('/miembros', formNuevoMiembro);
      setResultadoNuevoMiembro({ exito: true, mensaje: r.data.mensaje, password: r.data.password_temporal });
      setFormNuevoMiembro({ nombre:'', apellido_paterno:'', apellido_materno:'', telefono:'', ocupacion_general:'', nivel_estudios:'', estructura_id:'', cargo_id:'', seccion_id:'', sector_id:'', grupo_politico_id:'', lider_inmediato_id:'', fecha_inicio:'', observaciones:'' });
      fetchData();
    } catch(e) { setResultadoNuevoMiembro({ exito: false, mensaje: e.response?.data?.error || 'Error al crear miembro.' }); }
    finally { setGuardandoMiembro(false); }
  };

  const abrirEditarMiembro = (m) => {
    setMiembroEditando(m);
    setFormEditarMiembro({ estructura_id: m.estructura_id||'', cargo_id: m.cargo_id||'', seccion_id: m.seccion_id||'', sector_id: m.sector_id||'', grupo_politico_id: m.grupo_politico_id||'', lider_inmediato_id: m.lider_inmediato_id||'', fecha_inicio: m.fecha_inicio ? m.fecha_inicio.split('T')[0] : '', observaciones: m.observaciones||'' });
    setMostrarModalEditarMiembro(true);
  };
  const handleGuardarMiembro = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/miembros/${miembroEditando.id}`, formEditarMiembro);
      mostrarMensaje('exito','Miembro actualizado.');
      setMostrarModalEditarMiembro(false);
      fetchData();
    } catch(e) { mostrarMensaje('error', e.response?.data?.error || 'Error al actualizar.'); }
  };
  const handleEliminarMiembro = async (id) => {
    if (!window.confirm('¿Dar de baja a este miembro?')) return;
    try { await api.delete(`/miembros/${id}`); mostrarMensaje('exito','Miembro dado de baja.'); fetchData(); }
    catch(e) { mostrarMensaje('error','Error al eliminar.'); }
  };

  // ── Grupos ──
  const handleGuardarGrupo = async (e) => {
    e.preventDefault();
    try {
      if (editandoGrupo) { await api.put(`/estructuras/grupos/${editandoGrupo.id}`, formGrupo); mostrarMensaje('exito','Grupo actualizado.'); }
      else { await api.post('/estructuras/grupos', formGrupo); mostrarMensaje('exito','Grupo creado.'); }
      setFormGrupo({ nombre_grupo:'', descripcion:'' }); setMostrarFormGrupo(false); setEditandoGrupo(null);
      fetchData();
    } catch(e) { mostrarMensaje('error', e.response?.data?.error || 'Error.'); }
  };
  const handleEliminarGrupo = async (id) => {
    if (!window.confirm('¿Eliminar este grupo?')) return;
    try { await api.delete(`/estructuras/grupos/${id}`); mostrarMensaje('exito','Grupo eliminado.'); fetchData(); }
    catch(e) { mostrarMensaje('error','Error al eliminar.'); }
  };

  // ── Programas ──
  const handleGuardarPrograma = async (e) => {
    e.preventDefault();
    try {
      if (editandoPrograma) { await api.put(`/catalogos/programas-sociales/${editandoPrograma.id}`, formPrograma); mostrarMensaje('exito','Programa actualizado.'); }
      else { await api.post('/catalogos/programas-sociales', formPrograma); mostrarMensaje('exito','Programa creado.'); }
      setFormPrograma({ clave:'', etiqueta:'', orden:0 }); setMostrarFormPrograma(false); setEditandoPrograma(null);
      const r = await api.get('/catalogos/programas-sociales'); setProgramas(r.data.programas || []);
    } catch(e) { mostrarMensaje('error', e.response?.data?.error || 'Error.'); }
  };
  const handleEliminarPrograma = async (id) => {
    if (!window.confirm('¿Eliminar este programa?')) return;
    try { const r = await api.delete(`/catalogos/programas-sociales/${id}`); mostrarMensaje('exito', r.data.mensaje); const res = await api.get('/catalogos/programas-sociales'); setProgramas(res.data.programas || []); }
    catch(e) { mostrarMensaje('error','Error al eliminar.'); }
  };

  // ── Tipos Evidencia ──

  const handleGuardarNuevoParticipacion = async () => {
    if (!formNuevoParticipacion.nombre.trim() || !formNuevoParticipacion.clave.trim()) { mostrarMensaje('error','Nombre y clave son obligatorios.'); return; }
    try { await api.post('/catalogos/tipos-participacion', formNuevoParticipacion); mostrarMensaje('exito','Tipo agregado.'); setFormNuevoParticipacion({ nombre:'', clave:'' }); setMostrarNuevoParticipacion(false); const r = await api.get('/catalogos/tipos-participacion'); setTiposParticipacion(r.data.tipos||[]); }
    catch(e) { mostrarMensaje('error', e.response?.data?.error || 'Error.'); }
  };

  const handleGuardarEdicionParticipacion = async (id) => {
    try {
      await api.put('/catalogos/tipos-participacion/' + id, formEditParticipacion);
      mostrarMensaje('exito', 'Tipo actualizado.');
      setEditandoParticipacion(null);
      const r = await api.get('/catalogos/tipos-participacion');
      setTiposParticipacion(r.data.tipos || []);
    } catch(e) { mostrarMensaje('error', 'Error al actualizar.'); }
  };

  const handleEliminarParticipacion = async (t) => {
    if (!window.confirm('¿Eliminar este tipo?')) return;
    try { await api.delete('/catalogos/tipos-participacion/' + t.id); mostrarMensaje('exito','Tipo eliminado.'); const r = await api.get('/catalogos/tipos-participacion'); setTiposParticipacion(r.data.tipos||[]); }
    catch(e) { mostrarMensaje('error', 'Error al eliminar.'); }
  };
  const handleGuardarNuevoTipo = async () => {
    if (!formNuevoTipo.clave.trim() || !formNuevoTipo.etiqueta.trim()) { mostrarMensaje('error','Clave y nombre son obligatorios.'); return; }
    try { await api.post('/catalogos/tipos-evidencia', formNuevoTipo); mostrarMensaje('exito','Tipo agregado.'); setFormNuevoTipo({ clave:'', etiqueta:'', emoji:'📦', color:'#64748b' }); setMostrarNuevoTipo(false); const r = await api.get('/catalogos/tipos-evidencia'); setTiposEvidencia(r.data.tipos||[]); }
    catch(e) { mostrarMensaje('error', e.response?.data?.error||'Error.'); }
  };
  const handleGuardarEdicionTipo = async (id) => {
    try { await api.put(`/catalogos/tipos-evidencia/${id}`, formEditTipo); mostrarMensaje('exito','Tipo actualizado.'); setEditandoTipo(null); const r = await api.get('/catalogos/tipos-evidencia'); setTiposEvidencia(r.data.tipos||[]); }
    catch(e) { mostrarMensaje('error', e.response?.data?.error||'Error.'); }
  };
  const handleEliminarTipo = async (t) => {
    if (!window.confirm(`¿Eliminar "${t.etiqueta}"?`)) return;
    try { const r = await api.delete(`/catalogos/tipos-evidencia/${t.id}`); mostrarMensaje('exito', r.data.mensaje); const res = await api.get('/catalogos/tipos-evidencia'); setTiposEvidencia(res.data.tipos||[]); }
    catch(e) { mostrarMensaje('error', e.response?.data?.error||'Error.'); }
  };
  const toggleActivoTipo = async (t) => {
    try { await api.put(`/catalogos/tipos-evidencia/${t.id}`, { activo: !t.activo }); const r = await api.get('/catalogos/tipos-evidencia'); setTiposEvidencia(r.data.tipos||[]); }
    catch(e) { console.error(e); }
  };

  const [filtroNivel, setFiltroNivel] = useState('');
  const [filtroEstructura, setFiltroEstructura] = useState('');
  const [filtroSeccion, setFiltroSeccion] = useState('');
  const [filtroPrograma, setFiltroPrograma] = useState('');
  const [promovidosSeleccionados, setPromovidosSeleccionados] = useState([]);
  const [promotorDestino, setPromotorDestino] = useState('');
  const [asignandoPromotor, setAsignandoPromotor] = useState(false);
  const promotoresDisponibles = usuarios.filter(u => u.rol_nombre === 'promotor');
  const toggleSeleccionPromovido = (id) => {
    setPromovidosSeleccionados(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const handleAsignarPromotor = async () => {
    if (promovidosSeleccionados.length === 0 || !promotorDestino) return;
    setAsignandoPromotor(true);
    try {
      const r = await api.post('/capturas/reasignar-promotor', {
        persona_ids: promovidosSeleccionados,
        promotor_id: promotorDestino
      });
      mostrarMensaje('exito', r.data.mensaje);
      setPromovidosSeleccionados([]);
      setPromotorDestino('');
      fetchData();
    } catch (e) {
      mostrarMensaje('error', e.response?.data?.error || 'Error al asignar promotor.');
    } finally {
      setAsignandoPromotor(false);
    }
  };

  const promividosFiltrados = promovidos.filter(p => {
    const q = busqueda.toLowerCase();
    const coincideBusqueda = !busqueda || `${p.nombre} ${p.apellido_paterno} ${p.apellido_materno}`.toLowerCase().includes(q) || (p.telefono_principal||'').includes(q) || (p.clave_elector||'').toLowerCase().includes(q) || (p.programas_sociales||[]).some(prog => (prog||'').toLowerCase().includes(q));
    const coincideNivel = !filtroNivel || p.nivel_apoyo === filtroNivel;
    const coincideEstructura = !filtroEstructura || p.estructura_id_ganadora === filtroEstructura;
    const coincideSeccion = !filtroSeccion || String(p.seccion_id) === String(filtroSeccion);
    const coincidePrograma = !filtroPrograma || (p.programas_sociales||[]).some(prog => (prog||'').toUpperCase() === filtroPrograma.toUpperCase());
    return coincideBusqueda && coincideNivel && coincideEstructura && coincideSeccion && coincidePrograma;
  });

  // ── HEADER común ──
  const Header = ({ titulo, onBack }) => (
    <div className="mb-6">
      <button onClick={onBack} className="flex items-center gap-2 text-green-700 font-medium text-sm mb-3 hover:text-green-900 transition">
        <ChevronLeft size={18}/>
      </button>
      <h2 className="text-2xl font-bold text-gray-800">{titulo}</h2>
    </div>
  );

  if (loading) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center"><div className="w-10 h-10 border-4 border-green-600 border-t-transparent rounded-full animate-spin mx-auto mb-3"/><p className="text-gray-500">Cargando...</p></div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="text-white px-6 py-4 flex items-center justify-between shadow-lg"
        style={{ background: 'linear-gradient(135deg, #14532d 0%, #5c1022 100%)' }}>
        <div className="flex items-center gap-3">
          <img src={logo} alt="DOMINIUM" className="h-10"/>
          
        </div>
        <div className="flex items-center gap-3">
          {modulo && (
            <button onClick={() => { setModulo(null); setMostrarForm(false); setEditando(null); setBusqueda(''); }}
              className="bg-white bg-opacity-20 hover:bg-opacity-30 px-3 py-2 rounded-lg text-sm transition flex items-center gap-1">
              <Home size={16}/>
            </button>
          )}
          <button onClick={() => navigate('/dashboard')} title="Volver al Dashboard"
            className="bg-white bg-opacity-20 hover:bg-opacity-30 p-2 rounded-lg text-sm transition">
            <ChevronLeft size={20}/>
          </button>
        </div>
      </header>

      <main className="p-4 md:p-6 max-w-7xl mx-auto">

        {mensaje && (
          <div className={`mb-4 p-3 rounded-xl text-sm ${mensaje.tipo==='exito'?'bg-green-50 border border-green-200 text-green-800':'bg-red-50 border border-red-200 text-red-800'}`}>
            {mensaje.texto}
          </div>
        )}

        {/* ── DASHBOARD PRINCIPAL ── */}
        {!modulo && (
          <div>
            <div className="mb-6">
              <h2 className="text-2xl font-bold text-gray-800">⚙️ Panel de Administración</h2>
              <p className="text-gray-500 text-sm mt-1">Selecciona el módulo que deseas administrar</p>
            </div>

            {/* Stats rápidas */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
              {[
                { label:'Usuarios activos', valor: usuarios.length, color:'text-blue-600' },
                { label:'Promovidos', valor: promovidos.length, color:'text-green-600' },
                { label:'Estructuras', valor: estructuras.length, color:'text-orange-500' },
                { label:'Secciones', valor: secciones.length, color:'text-purple-600' },
              ].map(s => (
                <div key={s.label} className="bg-white rounded-xl shadow-sm p-4 border border-gray-100 text-center">
                  <p className={`text-2xl font-bold ${s.color}`}>{s.valor}</p>
                  <p className="text-xs text-gray-500 mt-1">{s.label}</p>
                </div>
              ))}
            </div>

            {/* Cards de módulos */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {MODULOS.map(m => (
                <div key={m.key} onClick={() => {
                    if (m.key === 'usuarios') { navigate('/usuarios?desde=admin'); return; }
                    if (m.key === 'casillas') { navigate('/casillas?desde=admin'); return; }
                    setModulo(m.key); setMostrarForm(false); setEditando(null); setBusqueda('');
                  }}
                  className="bg-white rounded-2xl shadow-sm hover:shadow-xl transition-shadow cursor-pointer group p-6 border border-gray-100">
                  <div className={`${m.color} w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform text-2xl`}>
                    {m.emoji}
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-1">{m.label}</h3>
                  <p className="text-sm text-gray-500 mb-4">{m.desc}</p>
                  <div className="flex items-center text-green-700 text-sm font-medium">
                    <span>Administrar</span>
                    <ChevronLeft size={16} className="ml-1 rotate-180 group-hover:translate-x-1 transition-transform"/>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── USUARIOS - redirige directo ── */}
        {modulo === 'usuarios' && null}

        {/* ── CASILLAS - redirige directo ── */}
        {modulo === 'casillas' && null}

        {/* ── SECCIONES ── */}
        {modulo === 'secciones' && (
          <div>
            <Header titulo="📍 Secciones Electorales" onBack={() => setModulo(null)}/>
            <div className="flex justify-between items-center mb-4">
              <p className="text-gray-500 text-sm">{secciones.length} secciones registradas</p>
              <button onClick={() => { setMostrarForm(!mostrarForm); setEditando(null); setFormSeccion({ numero_seccion:'', municipio:'', localidad:'', meta_votos:0, colonias:[] }); }}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white text-sm font-medium"
                style={{ background: 'linear-gradient(135deg, #16a34a, #15803d)' }}>
                <Plus size={16}/> {mostrarForm ? 'Cancelar' : 'Nueva Sección'}
              </button>
            </div>
            {mostrarForm && (
              <div className="bg-white rounded-xl shadow-sm p-6 mb-4 border border-gray-100">
                <form onSubmit={handleGuardarSeccion} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[{label:'Número de Sección *',key:'numero_seccion'},{label:'Municipio *',key:'municipio'},{label:'Localidad',key:'localidad'}].map(f => (
                    <div key={f.key}>
                      <label className="block text-sm font-medium text-gray-700 mb-1">{f.label}</label>
                      <input value={formSeccion[f.key]} onChange={e => setFormSeccion({...formSeccion,[f.key]:e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required={f.label.includes('*')}/>
                    </div>
                  ))}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Meta de Votos</label>
                    <input type="number" value={formSeccion.meta_votos} onChange={e => setFormSeccion({...formSeccion, meta_votos: parseInt(e.target.value)||0})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Colonias / Localidades</label>
                    <div className="space-y-2 mb-2">
                      {(formSeccion.colonias||[]).map((c,i) => (
                        <div key={i} className="flex gap-2">
                          <input value={c} onChange={e => { const u=[...formSeccion.colonias]; u[i]=e.target.value.toUpperCase(); setFormSeccion(p=>({...p,colonias:u})); }}
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm"/>
                          <button type="button" onClick={() => setFormSeccion(p=>({...p,colonias:p.colonias.filter((_,idx)=>idx!==i)}))}
                            className="px-3 py-2 bg-red-100 text-red-600 rounded-lg text-sm">Borrar</button>
                        </div>
                      ))}
                    </div>
                    <div className="flex gap-2">
                      <input value={nuevaColonia} onChange={e => setNuevaColonia(e.target.value.toUpperCase())} placeholder="Ej: COL CENTRO"
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm"/>
                      <button type="button" onClick={() => { if(nuevaColonia.trim()){ setFormSeccion(p=>({...p,colonias:[...(p.colonias||[]),nuevaColonia.trim()]})); setNuevaColonia(''); }}}
                        className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm">+ Agregar</button>
                    </div>
                  </div>
                  <div className="md:col-span-2">
                    <button type="submit" className="w-full text-white font-semibold py-2 rounded-lg hover:opacity-90"
                      style={{ background: 'linear-gradient(135deg, #16a34a, #9b1c35)' }}>
                      {editando ? 'Actualizar Sección' : 'Crear Sección'}
                    </button>
                  </div>
                </form>
              </div>
            )}
            <div className="bg-white rounded-xl shadow-sm overflow-x-auto border border-gray-100">
              <table className="w-full text-sm min-w-[600px]">
                <thead className="bg-gray-50 border-b">
                  <tr>{['Número','Localidad','Municipio','Colonias','Meta','Acciones'].map(h=><th key={h} className="text-left py-3 px-4 font-medium text-gray-600">{h}</th>)}</tr>
                </thead>
                <tbody>
                  {secciones.map(s => (
                    <tr key={s.id} className="border-b hover:bg-gray-50">
                      <td className="py-3 px-4 font-medium">{s.numero_seccion}</td>
                      <td className="py-3 px-4">{s.municipio}</td>
                      <td className="py-3 px-4">{s.localidad||'—'}</td>
                      <td className="py-3 px-4 text-xs text-gray-500">{(s.colonias||[]).length} colonia(s)</td>
                      <td className="py-3 px-4">{s.meta_votos||'—'}</td>
                      <td className="py-3 px-4 flex gap-2">
                        <button onClick={() => { setEditando(s); setFormSeccion({...s,colonias:s.colonias||[]}); setMostrarForm(true); }} className="p-1 hover:bg-blue-100 rounded"><Edit2 size={16} className="text-blue-600"/></button>
                        <button onClick={() => handleEliminarSeccion(s.id)} className="p-1 hover:bg-red-100 rounded"><Trash2 size={16} className="text-red-600"/></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ── ESTRUCTURAS ── */}
        {/* ── ESTRUCTURAS Y MIEMBROS UNIFICADO ── */}
        {modulo === 'org' && (
          <div>
            <Header titulo="🏗️ Estructuras y Miembros" onBack={() => setModulo(null)}/>

            {/* Pestañas internas */}
            <div className="flex gap-2 mb-6 border-b border-gray-200">
              <button onClick={() => { setPestanaOrg('estructuras'); setMostrarForm(false); setEditando(null); setMostrarFormMiembro(false); setResultadoNuevoMiembro(null); }}
                className={`px-5 py-3 text-sm font-semibold rounded-t-lg transition ${pestanaOrg==='estructuras'?'bg-white border border-b-white border-gray-200 text-teal-700 -mb-px':'text-gray-500 hover:text-gray-700'}`}>
                🏛️ Estructuras ({estructuras.length})
              </button>
              <button onClick={() => { setPestanaOrg('miembros'); setMostrarForm(false); setEditando(null); setMostrarFormMiembro(false); setResultadoNuevoMiembro(null); }}
                className={`px-5 py-3 text-sm font-semibold rounded-t-lg transition ${pestanaOrg==='miembros'?'bg-white border border-b-white border-gray-200 text-orange-700 -mb-px':'text-gray-500 hover:text-gray-700'}`}>
                👥 Miembros ({miembros.length})
              </button>
            </div>

            {/* ── PESTAÑA ESTRUCTURAS ── */}
            {pestanaOrg === 'estructuras' && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <p className="text-gray-500 text-sm">{estructuras.length} estructuras registradas</p>
                  <button onClick={() => { setMostrarForm(!mostrarForm); setEditando(null); setFormEstructura({ nombre_estructura:'', tipo_estructura:'', grupo_politico_id:'', seccion_id:'', sector_id:'' }); }}
                    className="flex items-center gap-2 px-4 py-2 rounded-lg text-white text-sm font-medium"
                    style={{ background: 'linear-gradient(135deg, #16a34a, #15803d)' }}>
                    <Plus size={16}/> {mostrarForm ? 'Cancelar' : 'Nueva Estructura'}
                  </button>
                </div>
                {mostrarForm && (
                  <div className="bg-white rounded-xl shadow-sm p-6 mb-4 border border-gray-100">
                    <form onSubmit={handleGuardarEstructura} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
                        <input value={formEstructura.nombre_estructura} onChange={e => setFormEstructura({...formEstructura,nombre_estructura:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required/>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
                        <select value={formEstructura.tipo_estructura} onChange={e => setFormEstructura({...formEstructura,tipo_estructura:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                          <option value="">Seleccionar...</option>
                          {['Territorial','Sectorial','Seccional','Operativa','politica'].map(t => <option key={t} value={t}>{t}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Sección Electoral</label>
                        <select value={formEstructura.seccion_id} onChange={e => setFormEstructura({...formEstructura,seccion_id:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                          <option value="">Seleccionar...</option>
                          {catalogosMiembros.secciones?.map(s => <option key={s.id} value={s.id}>{s.numero_seccion} - {s.municipio}</option>)}
                        </select>
                      </div>
                      <div className="md:col-span-2">
                        <button type="submit" className="w-full text-white font-semibold py-2 rounded-lg hover:opacity-90"
                          style={{ background: 'linear-gradient(135deg, #16a34a, #9b1c35)' }}>
                          {editando ? 'Actualizar Estructura' : 'Crear Estructura'}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
                <div className="bg-white rounded-xl shadow-sm overflow-x-auto border border-gray-100">
                  <table className="w-full text-sm min-w-[500px]">
                    <thead className="bg-gray-50 border-b">
                      <tr>{['Nombre','Tipo','Sección','Acciones'].map(h=><th key={h} className="text-left py-3 px-4 font-medium text-gray-600">{h}</th>)}</tr>
                    </thead>
                    <tbody>
                      {estructuras.length === 0
                        ? <tr><td colSpan="4" className="py-8 text-center text-gray-400">No hay estructuras registradas</td></tr>
                        : estructuras.map(e => (
                          <tr key={e.id} className="border-b hover:bg-gray-50">
                            <td className="py-3 px-4 font-medium">{e.nombre_estructura}</td>
                            <td className="py-3 px-4">{e.tipo_estructura||'—'}</td>
                            <td className="py-3 px-4">{e.numero_seccion ? `Sec. ${e.numero_seccion}` : '—'}</td>
                            <td className="py-3 px-4 flex gap-2">
                              <button onClick={() => { setEditando(e); setFormEstructura({...e}); setMostrarForm(true); }} className="p-1 hover:bg-blue-100 rounded"><Edit2 size={16} className="text-blue-600"/></button>
                              <button onClick={() => handleEliminarEstructura(e.id)} className="p-1 hover:bg-red-100 rounded"><Trash2 size={16} className="text-red-600"/></button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* ── PESTAÑA MIEMBROS ── */}
            {pestanaOrg === 'miembros' && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <p className="text-gray-500 text-sm">{miembros.length} miembros registrados</p>
                  <button onClick={() => { setMostrarFormMiembro(!mostrarFormMiembro); setResultadoNuevoMiembro(null); }}
                    className="flex items-center gap-2 px-4 py-2 rounded-lg text-white text-sm font-medium"
                    style={{ background: 'linear-gradient(135deg, #16a34a, #15803d)' }}>
                    <Plus size={16}/> {mostrarFormMiembro ? 'Cancelar' : 'Nuevo Miembro'}
                  </button>
                </div>

                {mostrarFormMiembro && (
                  <div className="bg-white rounded-xl shadow-sm p-6 mb-4 border border-gray-100">
                    <p className="text-sm font-semibold text-gray-700 mb-4">➕ Alta de nuevo miembro de estructura</p>
                    {resultadoNuevoMiembro && (
                      <div className={`p-3 rounded-lg text-sm mb-4 ${resultadoNuevoMiembro.exito?'bg-green-50 border border-green-200 text-green-800':'bg-red-50 border border-red-200 text-red-800'}`}>
                        {resultadoNuevoMiembro.mensaje}
                        {resultadoNuevoMiembro.password && <span className="block mt-1 font-bold">🔑 Contraseña temporal: {resultadoNuevoMiembro.password}</span>}
                      </div>
                    )}
                    <form onSubmit={handleCrearMiembro} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
                        <input value={formNuevoMiembro.nombre} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,nombre:e.target.value.toUpperCase()})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required/>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Apellido Paterno *</label>
                        <input value={formNuevoMiembro.apellido_paterno} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,apellido_paterno:e.target.value.toUpperCase()})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required/>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Apellido Materno</label>
                        <input value={formNuevoMiembro.apellido_materno} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,apellido_materno:e.target.value.toUpperCase()})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono * (10 dígitos)</label>
                        <input value={formNuevoMiembro.telefono} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,telefono:e.target.value})}
                          inputMode="numeric" maxLength={10}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required/>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Estructura *</label>
                        <select value={formNuevoMiembro.estructura_id} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,estructura_id:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required>
                          <option value="">Seleccionar...</option>
                          {estructuras.map(e => <option key={e.id} value={e.id}>{e.nombre_estructura}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Cargo *</label>
                        <select value={formNuevoMiembro.cargo_id} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,cargo_id:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required>
                          <option value="">Seleccionar...</option>
                          {catalogosMiembros.cargos?.map(c => <option key={c.id} value={c.id}>{c.nombre_cargo}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Sección Electoral</label>
                        <select value={formNuevoMiembro.seccion_id} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,seccion_id:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                          <option value="">Seleccionar...</option>
                          {catalogosMiembros.secciones?.map(s => <option key={s.id} value={s.id}>{s.numero_seccion} - {s.municipio}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Líder Inmediato</label>
                        <select value={formNuevoMiembro.lider_inmediato_id} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,lider_inmediato_id:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                          <option value="">Sin líder asignado</option>
                          {catalogosMiembros.miembros_para_lider?.map(m => <option key={m.id} value={m.id}>{m.nombre} {m.apellido_paterno} — {m.nombre_cargo||m.rol_nombre}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de Inicio</label>
                        <input type="date" value={formNuevoMiembro.fecha_inicio} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,fecha_inicio:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Ocupación</label>
                        <select value={formNuevoMiembro.ocupacion_general} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,ocupacion_general:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                          <option value="">Seleccionar...</option>
                          {['comerciante','docente','profesionista','ama_de_casa','campesino','servidor_publico','empleado_privado','empresario','desempleado','estudiante','otro'].map(o => <option key={o} value={o}>{o.replace(/_/g,' ')}</option>)}
                        </select>
                      </div>
                      <div className="md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Observaciones</label>
                        <input value={formNuevoMiembro.observaciones} onChange={e => setFormNuevoMiembro({...formNuevoMiembro,observaciones:e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
                      </div>
                      <div className="md:col-span-2">
                        <button type="submit" disabled={guardandoMiembro} className="w-full text-white font-semibold py-2 rounded-lg hover:opacity-90 disabled:opacity-50"
                          style={{ background: 'linear-gradient(135deg, #16a34a, #9b1c35)' }}>
                          {guardandoMiembro ? 'Creando miembro...' : '✅ Dar de Alta como Miembro'}
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                <div className="bg-white rounded-xl shadow-sm overflow-x-auto border border-gray-100">
                  <table className="w-full text-sm min-w-[700px]">
                    <thead className="bg-gray-50 border-b">
                      <tr>{['Nombre','Cargo','Estructura','Sección','Acciones'].map(h=><th key={h} className="text-left py-3 px-4 font-medium text-gray-600">{h}</th>)}</tr>
                    </thead>
                    <tbody>
                      {miembros.length === 0
                        ? <tr><td colSpan="5" className="py-8 text-center text-gray-400">No hay miembros registrados</td></tr>
                        : miembros.map(m => (
                          <tr key={m.id} className="border-b hover:bg-gray-50">
                            <td className="py-3 px-4 font-medium">{m.nombre} {m.apellido_paterno}</td>
                            <td className="py-3 px-4">{m.nombre_cargo||'—'}</td>
                            <td className="py-3 px-4">{m.nombre_estructura||'—'}</td>
                            <td className="py-3 px-4">{m.numero_seccion||'—'}</td>
                            <td className="py-3 px-4 flex gap-2">
                              <button onClick={() => abrirEditarMiembro(m)} className="p-1 hover:bg-blue-100 rounded"><Edit2 size={16} className="text-blue-600"/></button>
                              <button onClick={() => handleEliminarMiembro(m.id)} className="p-1 hover:bg-red-100 rounded"><Trash2 size={16} className="text-red-600"/></button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── PROMOVIDOS ── */}
        {modulo === 'promovidos' && (() => {
          // Conteos por nivel de apoyo
          const conteos = {
            total: promovidos.length,
            simpatizante: promovidos.filter(p => p.nivel_apoyo === 'seguro' || p.nivel_apoyo === 'simpatizante').length,
            defensa_del_voto: promovidos.filter(p => p.nivel_apoyo === 'defensa_del_voto').length,
            indeciso: promovidos.filter(p => p.nivel_apoyo === 'indeciso').length,
          };

          const descargarExcel = () => {
            const filas = promividosFiltrados.map(p => [
              `${p.nombre} ${p.apellido_paterno} ${p.apellido_materno||''}`.trim(),
              p.telefono_principal || '',
              p.numero_seccion || '',
              (p.nivel_apoyo || '').replace(/_/g, ' ').toUpperCase(),
              p.clave_elector || '',
              p.colonia || '',
              p.municipio || ''
            ]);
            const encabezado = ['Nombre','Teléfono','Sección','Nivel Apoyo','Clave Elector','Colonia','Municipio'];
            const contenido = [encabezado, ...filas].map(r => r.join('\t')).join('\n');
            const blob = new Blob([contenido], { type: 'text/tab-separated-values;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = 'promovidos.xls'; a.click();
            URL.revokeObjectURL(url);
          };

          return (
            <div>
              <Header titulo="📋 Promovidos" onBack={() => setModulo(null)}/>

              {/* Mini dashboard de conteos */}
              <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-4">
                {[
                  { label: 'Total', valor: conteos.total, color: 'text-gray-700', bg: 'bg-gray-50', border: 'border-gray-200', filtro: '' },
                  { label: '✅ Simpatizantes', valor: conteos.simpatizante, color: 'text-green-700', bg: 'bg-green-50', border: 'border-green-200', filtro: 'simpatizante' },
                  { label: '🛡️ Defensa Voto', valor: conteos.defensa_del_voto, color: 'text-blue-700', bg: 'bg-blue-50', border: 'border-blue-200', filtro: 'defensa_del_voto' },
                  { label: '❓ Indecisos', valor: conteos.indeciso, color: 'text-orange-700', bg: 'bg-orange-50', border: 'border-orange-200', filtro: 'indeciso' },
                ].map(c => (
                  <button key={c.filtro} onClick={() => setFiltroNivel(filtroNivel === c.filtro ? '' : c.filtro)}
                    className={`${c.bg} border ${c.border} rounded-xl p-3 text-center cursor-pointer transition hover:opacity-80 ${filtroNivel === c.filtro ? 'ring-2 ring-offset-1 ring-green-500' : ''}`}>
                    <div className={`text-2xl font-bold ${c.color}`}>{c.valor}</div>
                    <div className="text-xs text-gray-500 mt-1">{c.label}</div>
                  </button>
                ))}
              </div>

              {/* Buscador + filtro nivel + botón Excel */}
              <div className="bg-white rounded-xl shadow-sm p-4 mb-4 border border-gray-100">
                <div className="flex flex-col md:flex-row gap-3">
                  <div className="relative flex-1">
                    <Search size={18} className="absolute left-3 top-3 text-gray-400"/>
                    <input value={busqueda} onChange={e => setBusqueda(e.target.value)}
                      placeholder="Buscar por nombre, teléfono, clave o programa social..."
                      className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
                  </div>
                  <select value={filtroNivel} onChange={e => setFiltroNivel(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm">
                    <option value="">Todos los niveles</option>
                    <option value="seguro">Seguro</option>
                    <option value="defensa_del_voto">Defensa del Voto</option>
                    <option value="simpatizante">Simpatizante</option>
                    <option value="indeciso">Indeciso</option>
                  </select>
                  <select value={filtroEstructura} onChange={e => setFiltroEstructura(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm">
                    <option value="">Todas las estructuras</option>
                    {estructuras.map(e => <option key={e.id} value={e.id}>{e.nombre_estructura}</option>)}
                  </select>
                  <select value={filtroSeccion} onChange={e => setFiltroSeccion(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm">
                    <option value="">Todas las secciones</option>
                    {secciones.map(s => <option key={s.id} value={s.id}>{s.numero_seccion}</option>)}
                  </select>
                  <select value={filtroPrograma} onChange={e => setFiltroPrograma(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm">
                    <option value="">Todos los programas sociales</option>
                    {programas.map(pr => <option key={pr.id} value={pr.clave}>{pr.etiqueta}</option>)}
                  </select>
                  <button onClick={descargarExcel}
                    className="flex items-center gap-2 px-4 py-2 bg-green-700 text-white rounded-lg text-sm font-medium hover:bg-green-800 transition">
                    ⬇️ Descargar Excel
                  </button>
                </div>
                {(filtroNivel || filtroEstructura || filtroSeccion || filtroPrograma) && (
                  <p className="text-xs text-gray-500 mt-2">
                    Mostrando {promividosFiltrados.length} de {promovidos.length} promovidos
                    — <button onClick={() => { setFiltroNivel(''); setFiltroEstructura(''); setFiltroSeccion(''); setFiltroPrograma(''); }} className="text-green-600 underline">Quitar filtros</button>
                  </p>
                )}
              </div>

              {promovidosSeleccionados.length > 0 && (
                <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-4 flex flex-col md:flex-row gap-3 items-start md:items-center">
                  <span className="text-sm font-medium text-green-800">
                    {promovidosSeleccionados.length} promovido(s) seleccionado(s)
                  </span>
                  <select value={promotorDestino} onChange={e => setPromotorDestino(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm flex-1">
                    <option value="">Seleccionar promotor destino...</option>
                    {promotoresDisponibles.map(u => (
                      <option key={u.id} value={u.id}>{u.nombre} {u.apellido_paterno}</option>
                    ))}
                  </select>
                  <button onClick={handleAsignarPromotor} disabled={!promotorDestino || asignandoPromotor}
                    className="px-4 py-2 bg-green-700 text-white rounded-lg text-sm font-medium hover:bg-green-800 transition disabled:opacity-50 whitespace-nowrap">
                    {asignandoPromotor ? 'Asignando...' : '🤝 Asignar a Promotor'}
                  </button>
                  <button onClick={() => setPromovidosSeleccionados([])}
                    className="text-sm text-gray-500 underline whitespace-nowrap">
                    Cancelar selección
                  </button>
                </div>
              )}

              <div className="bg-white rounded-xl shadow-sm overflow-x-auto border border-gray-100">
                <table className="w-full text-sm min-w-[700px]">
                  <thead className="bg-gray-50 border-b">
                    <tr>
                      <th className="text-left py-3 px-4 font-medium text-gray-600 w-10">
                        <input type="checkbox"
                          checked={promividosFiltrados.length > 0 && promovidosSeleccionados.length === promividosFiltrados.length}
                          onChange={() => setPromovidosSeleccionados(promovidosSeleccionados.length === promividosFiltrados.length ? [] : promividosFiltrados.map(p => p.id))}
                        />
                      </th>
                      {['Nombre','Teléfono','Sección','Capturado por','Programas Sociales','Nivel Apoyo','Acciones'].map(h=><th key={h} className="text-left py-3 px-4 font-medium text-gray-600">{h}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {promividosFiltrados.length === 0
                      ? <tr><td colSpan="8" className="py-8 text-center text-gray-400">No se encontraron promovidos</td></tr>
                      : promividosFiltrados.map(p => (
                        <tr key={p.id} className="border-b hover:bg-gray-50">
                          <td className="py-3 px-4">
                            <input type="checkbox"
                              checked={promovidosSeleccionados.includes(p.id)}
                              onChange={() => toggleSeleccionPromovido(p.id)}
                            />
                          </td>
                          <td className="py-3 px-4 font-medium">{p.nombre} {p.apellido_paterno} {p.apellido_materno}</td>
                          <td className="py-3 px-4">{p.telefono_principal}</td>
                          <td className="py-3 px-4">{p.numero_seccion||'—'}</td>
                          <td className="py-3 px-4 text-gray-600">{p.capturado_por_nombre||'—'}</td>
                          <td className="py-3 px-4">
                            {(p.programas_sociales && p.programas_sociales.length > 0)
                              ? <div className="flex flex-wrap gap-1 max-w-[220px]">
                                  {p.programas_sociales.map((prog, idx) => (
                                    <span key={idx} className="px-2 py-0.5 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200">
                                      {formatearPrograma(prog)}
                                    </span>
                                  ))}
                                </div>
                              : <span className="text-gray-400">—</span>}
                          </td>
                          <td className="py-3 px-4"><span className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${getNivelColor(p.nivel_apoyo)}`}>{(p.nivel_apoyo||'—').replace(/_/g,' ')}</span></td>
                          <td className="py-3 px-4">
                            <div className="flex gap-1">
                              <button onClick={() => abrirEditarPromovido(p)} title="Editar promovido"
                                className="p-1 hover:bg-blue-100 rounded"><Edit2 size={16} className="text-blue-600"/></button>
                              <button onClick={() => abrirModalPromover(p)} title="Promover a rol del sistema"
                                className="p-1 hover:bg-purple-100 rounded"><ArrowUpCircle size={16} className="text-purple-600"/></button>
                              <button onClick={() => handleEliminarPromovido(p)} title="Eliminar promovido"
                                className="p-1 hover:bg-red-100 rounded"><Trash2 size={16} className="text-red-600"/></button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })()}



        {/* ── GRUPOS POLÍTICOS ── */}
        {modulo === 'grupos' && (
          <div>
            <Header titulo="🎯 Grupos Políticos" onBack={() => setModulo(null)}/>
            <div className="flex justify-between items-center mb-4">
              <p className="text-gray-500 text-sm">{grupos.length} grupos registrados</p>
              <button onClick={() => { setMostrarFormGrupo(!mostrarFormGrupo); setEditandoGrupo(null); setFormGrupo({ nombre_grupo:'', descripcion:'' }); }}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white text-sm font-medium"
                style={{ background: 'linear-gradient(135deg, #16a34a, #15803d)' }}>
                <Plus size={16}/> {mostrarFormGrupo ? 'Cancelar' : 'Nuevo Grupo'}
              </button>
            </div>
            {mostrarFormGrupo && (
              <div className="bg-white rounded-xl shadow-sm p-5 mb-4 border border-gray-100">
                <form onSubmit={handleGuardarGrupo} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del grupo *</label>
                    <input value={formGrupo.nombre_grupo} onChange={e => setFormGrupo({...formGrupo,nombre_grupo:e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required/>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                    <input value={formGrupo.descripcion} onChange={e => setFormGrupo({...formGrupo,descripcion:e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
                  </div>
                  <div className="md:col-span-2">
                    <button type="submit" className="w-full text-white font-semibold py-2 rounded-lg hover:opacity-90"
                      style={{ background: 'linear-gradient(135deg, #16a34a, #9b1c35)' }}>
                      {editandoGrupo ? 'Actualizar' : 'Crear Grupo'}
                    </button>
                  </div>
                </form>
              </div>
            )}
            <div className="bg-white rounded-xl shadow-sm divide-y border border-gray-100">
              {grupos.length === 0 ? <p className="text-center text-gray-400 py-8">No hay grupos registrados.</p>
                : grupos.map(g => (
                  <div key={g.id} className="flex items-center gap-4 p-4">
                    <div className="flex-1">
                      <p className="font-medium text-gray-800">{g.nombre_grupo}</p>
                      {g.descripcion && <p className="text-xs text-gray-400">{g.descripcion}</p>}
                    </div>
                    <button onClick={() => { setEditandoGrupo(g); setFormGrupo({nombre_grupo:g.nombre_grupo,descripcion:g.descripcion||''}); setMostrarFormGrupo(true); }}
                      className="p-1 hover:bg-blue-100 rounded"><Edit2 size={16} className="text-blue-600"/></button>
                    <button onClick={() => handleEliminarGrupo(g.id)} className="p-1 hover:bg-red-100 rounded"><Trash2 size={16} className="text-red-600"/></button>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* ── PROGRAMAS SOCIALES ── */}
        {modulo === 'programas' && (
          <div>
            <Header titulo="🤝 Programas Sociales" onBack={() => setModulo(null)}/>
            <div className="flex justify-between items-center mb-4">
              <p className="text-gray-500 text-sm">{programas.length} programas registrados</p>
              <button onClick={() => { setMostrarFormPrograma(!mostrarFormPrograma); setEditandoPrograma(null); setFormPrograma({ clave:'', etiqueta:'', orden:0 }); }}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white text-sm font-medium"
                style={{ background: 'linear-gradient(135deg, #16a34a, #15803d)' }}>
                <Plus size={16}/> {mostrarFormPrograma ? 'Cancelar' : 'Nuevo Programa'}
              </button>
            </div>
            {mostrarFormPrograma && (
              <div className="bg-white rounded-xl shadow-sm p-5 mb-4 border border-gray-100">
                <form onSubmit={handleGuardarPrograma} className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Clave *</label>
                    <input value={formPrograma.clave} onChange={e => setFormPrograma({...formPrograma,clave:e.target.value})}
                      placeholder="ej: becas_bienestar" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required/>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
                    <input value={formPrograma.etiqueta} onChange={e => setFormPrograma({...formPrograma,etiqueta:e.target.value})}
                      placeholder="ej: Becas Bienestar" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required/>
                  </div>
                  <div className="flex items-end">
                    <button type="submit" className="w-full text-white font-semibold py-2 rounded-lg hover:opacity-90"
                      style={{ background: 'linear-gradient(135deg, #16a34a, #9b1c35)' }}>
                      {editandoPrograma ? 'Actualizar' : 'Crear'}
                    </button>
                  </div>
                </form>
              </div>
            )}
            <div className="bg-white rounded-xl shadow-sm divide-y border border-gray-100">
              {programas.length === 0 ? <p className="text-center text-gray-400 py-8">No hay programas registrados.</p>
                : programas.map(p => (
                  <div key={p.id} className={`flex items-center gap-4 p-4 ${!p.activo?'opacity-50':''}`}>
                    <span className="text-2xl">{p.emoji || '🏛️'}</span>
                    <div className="flex-1">
                      <p className="font-medium text-gray-800">{p.etiqueta}</p>
                      <p className="text-xs text-gray-400">clave: {p.clave} {!p.activo && '• (inactivo)'}</p>
                    </div>
                    <button onClick={() => { setEditandoPrograma(p); setFormPrograma({clave:p.clave,etiqueta:p.etiqueta,orden:p.orden}); setMostrarFormPrograma(true); }}
                      className="p-1 hover:bg-blue-100 rounded"><Edit2 size={16} className="text-blue-600"/></button>
                    <button onClick={() => handleEliminarPrograma(p.id)} className="p-1 hover:bg-red-100 rounded"><Trash2 size={16} className="text-red-600"/></button>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* ── TIPOS DE EVIDENCIA ── */}
        {modulo === 'participacion' && (
          <div>
            <Header titulo="🤝 Tipos de Participación" onBack={() => setModulo(null)}/>
            <div className="flex justify-between items-center mb-4">
              <p className="text-gray-500 text-sm">Tipos que aparecen en Toca y Promueve</p>
              <button onClick={() => setMostrarNuevoParticipacion(!mostrarNuevoParticipacion)}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white text-sm font-medium"
                style={{ background: 'linear-gradient(135deg, #7c3aed, #6d28d9)' }}>
                <Plus size={16}/> {mostrarNuevoParticipacion ? 'Cancelar' : 'Nuevo Tipo'}
              </button>
            </div>
            {mostrarNuevoParticipacion && (
              <div className="bg-white rounded-xl shadow-sm p-5 mb-4 border border-gray-100">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  <div><label className="block text-xs text-gray-500 mb-1">Nombre</label><input value={formNuevoParticipacion.nombre} onChange={e => setFormNuevoParticipacion(p=>({...p,nombre:e.target.value}))} placeholder="ej: Trabajo comunitario" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"/></div>
                  <div><label className="block text-xs text-gray-500 mb-1">Clave</label><input value={formNuevoParticipacion.clave} onChange={e => setFormNuevoParticipacion(p=>({...p,clave:e.target.value}))} placeholder="ej: trabajo_comunitario" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"/></div>
                  <div className="flex items-end gap-2">
                    <button onClick={handleGuardarNuevoParticipacion} className="flex-1 py-2 rounded-lg text-white text-sm font-medium" style={{background:'linear-gradient(135deg,#7c3aed,#6d28d9)'}}>Guardar</button>
                    <button onClick={() => setMostrarNuevoParticipacion(false)} className="flex-1 py-2 rounded-lg border border-gray-300 text-gray-600 text-sm">Cancelar</button>
                  </div>
                </div>
              </div>
            )}
            <div className="bg-white rounded-xl shadow-sm divide-y border border-gray-100">
              {tiposParticipacion.length === 0 ? <p className="text-center text-gray-400 py-8">No hay tipos registrados.</p>
                : tiposParticipacion.map(t => (
                  <div key={t.id} className="p-4 flex items-center gap-3">
                    <span className="text-2xl">🤝</span>
                    <div className="flex-1">
                      {editandoParticipacion === t.id
                        ? <div className="flex gap-2">
                            <input value={formEditParticipacion.nombre} onChange={e => setFormEditParticipacion(p=>({...p,nombre:e.target.value}))} className="flex-1 px-2 py-1 border border-purple-300 rounded text-sm"/>
                            <input value={formEditParticipacion.clave} onChange={e => setFormEditParticipacion(p=>({...p,clave:e.target.value}))} className="w-40 px-2 py-1 border border-purple-300 rounded text-sm"/>
                          </div>
                        : <><p className="text-sm font-medium text-gray-800">{t.nombre}</p><p className="text-xs text-gray-400">clave: {t.clave}</p></>
                      }
                    </div>
                    <div className="flex items-center gap-2">
                      {editandoParticipacion === t.id
                        ? <><button onClick={() => handleGuardarEdicionParticipacion(t.id)} className="p-2 rounded-lg bg-green-100 text-green-700 hover:bg-green-200"><Check size={16}/></button>
                            <button onClick={() => setEditandoParticipacion(null)} className="p-2 rounded-lg bg-gray-100 text-gray-500 hover:bg-gray-200"><X size={16}/></button></>
                        : <><button onClick={() => { setEditandoParticipacion(t.id); setFormEditParticipacion({nombre:t.nombre,clave:t.clave}); }} className="p-2 rounded-lg bg-blue-100 text-blue-700 hover:bg-blue-200"><Edit2 size={14}/></button>
                            <button onClick={() => handleEliminarParticipacion(t)} className="p-2 rounded-lg bg-red-100 text-red-700 hover:bg-red-200"><Trash2 size={14}/></button></>
                      }
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {modulo === 'evidencias' && (
          <div>
            <Header titulo="📸 Tipos de Evidencia" onBack={() => setModulo(null)}/>
            <div className="flex justify-between items-center mb-4">
              <p className="text-gray-500 text-sm">Tipos que aparecen en Cobertura en Campo</p>
              <button onClick={() => setMostrarNuevoTipo(!mostrarNuevoTipo)}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white text-sm font-medium"
                style={{ background: 'linear-gradient(135deg, #16a34a, #15803d)' }}>
                <Plus size={16}/> {mostrarNuevoTipo ? 'Cancelar' : 'Nuevo Tipo'}
              </button>
            </div>
            {mostrarNuevoTipo && (
              <div className="bg-white rounded-xl shadow-sm p-5 mb-4 border border-gray-100">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  <div><label className="block text-xs text-gray-500 mb-1">Clave</label><input value={formNuevoTipo.clave} onChange={e => setFormNuevoTipo(p=>({...p,clave:e.target.value}))} placeholder="ej: manta" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"/></div>
                  <div><label className="block text-xs text-gray-500 mb-1">Nombre</label><input value={formNuevoTipo.etiqueta} onChange={e => setFormNuevoTipo(p=>({...p,etiqueta:e.target.value}))} placeholder="ej: Manta" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"/></div>
                  <div><label className="block text-xs text-gray-500 mb-1">Emoji</label><input value={formNuevoTipo.emoji} onChange={e => setFormNuevoTipo(p=>({...p,emoji:e.target.value}))} placeholder="🪧" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"/></div>
                  <div className="flex items-end gap-2">
                    <button onClick={handleGuardarNuevoTipo} className="flex-1 py-2 rounded-lg bg-green-600 text-white text-sm font-medium">Guardar</button>
                    <button onClick={() => setMostrarNuevoTipo(false)} className="flex-1 py-2 rounded-lg border border-gray-300 text-gray-600 text-sm">Cancelar</button>
                  </div>
                </div>
              </div>
            )}
            <div className="bg-white rounded-xl shadow-sm divide-y border border-gray-100">
              {tiposEvidencia.length === 0 ? <p className="text-center text-gray-400 py-8">No hay tipos registrados.</p>
                : tiposEvidencia.map(t => (
                  <div key={t.id} className={`p-4 flex items-center gap-3 ${!t.activo?'opacity-50':''}`}>
                    <span className="text-2xl">{t.emoji}</span>
                    <div className="flex-1">
                      {editandoTipo === t.id
                        ? <div className="flex gap-2">
                            <input value={formEditTipo.emoji} onChange={e => setFormEditTipo(p=>({...p,emoji:e.target.value}))} className="w-16 px-2 py-1 border border-green-300 rounded text-sm" placeholder="emoji"/>
                            <input value={formEditTipo.etiqueta} onChange={e => setFormEditTipo(p=>({...p,etiqueta:e.target.value}))} className="flex-1 px-2 py-1 border border-green-300 rounded text-sm"/>
                          </div>
                        : <><p className="text-sm font-medium text-gray-800">{t.etiqueta}</p><p className="text-xs text-gray-400">clave: {t.clave} {!t.activo && '• (desactivado)'}</p></>
                      }
                    </div>
                    <div className="flex items-center gap-2">
                      {editandoTipo === t.id
                        ? <><button onClick={() => handleGuardarEdicionTipo(t.id)} className="p-2 rounded-lg bg-green-100 text-green-700 hover:bg-green-200"><Check size={16}/></button>
                            <button onClick={() => setEditandoTipo(null)} className="p-2 rounded-lg bg-gray-100 text-gray-500 hover:bg-gray-200"><X size={16}/></button></>
                        : <><button onClick={() => toggleActivoTipo(t)} className={`px-2 py-1 rounded-lg text-xs font-medium ${t.activo?'bg-green-100 text-green-700':'bg-gray-100 text-gray-500'}`}>{t.activo?'Activo':'Inactivo'}</button>
                            <button onClick={() => { setEditandoTipo(t.id); setFormEditTipo({etiqueta:t.etiqueta,emoji:t.emoji,color:t.color}); }} className="p-2 rounded-lg bg-blue-100 text-blue-700 hover:bg-blue-200"><Edit2 size={14}/></button>
                            <button onClick={() => handleEliminarTipo(t)} className="p-2 rounded-lg bg-red-100 text-red-700 hover:bg-red-200"><Trash2 size={14}/></button></>
                      }
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

      </main>

      {/* ── MODAL EDITAR PROMOVIDO ── */}
      {mostrarModalEditarPromovido && promovidoEditando && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-5 text-white rounded-t-2xl flex justify-between items-center sticky top-0 z-10" style={{ background:'linear-gradient(135deg,#14532d,#5c1022)' }}>
              <h3 className="font-bold text-lg">Editar Promovido</h3>
              <button onClick={() => setMostrarModalEditarPromovido(false)} className="hover:bg-white hover:bg-opacity-20 p-1 rounded"><X size={20}/></button>
            </div>
            <form onSubmit={handleGuardarEditarPromovido} className="p-6 space-y-5">
              <div>
                <p className="text-sm font-semibold mb-3" style={{color:'#14532d'}}>1. Datos Personales</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
                    <input value={formEditarPromovido.nombre || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, nombre: e.target.value})} required className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Apellido Paterno *</label>
                    <input value={formEditarPromovido.apellido_paterno || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, apellido_paterno: e.target.value})} required className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Apellido Materno</label>
                    <input value={formEditarPromovido.apellido_materno || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, apellido_materno: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Telefono Principal *</label>
                    <input value={formEditarPromovido.telefono_principal || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, telefono_principal: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Telefono Alterno</label>
                    <input value={formEditarPromovido.telefono_alterno || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, telefono_alterno: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Clave de Elector</label>
                    <input value={formEditarPromovido.clave_elector || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, clave_elector: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                </div>
              </div>
              <div>
                <p className="text-sm font-semibold mb-3" style={{color:'#14532d'}}>2. Domicilio</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2"><label className="block text-sm font-medium text-gray-700 mb-1">Domicilio Breve</label>
                    <input value={formEditarPromovido.domicilio_breve || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, domicilio_breve: e.target.value})} placeholder="Ej: Calle Hidalgo 23, Col. Centro" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Calle</label>
                    <input value={formEditarPromovido.calle || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, calle: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Num. Exterior</label>
                    <input value={formEditarPromovido.numero_exterior || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, numero_exterior: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Colonia / Barrio</label>
                    <input value={formEditarPromovido.colonia || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, colonia: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Codigo Postal</label>
                    <input value={formEditarPromovido.codigo_postal || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, codigo_postal: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div className="md:col-span-2"><label className="block text-sm font-medium text-gray-700 mb-1">Referencias</label>
                    <input value={formEditarPromovido.referencias || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, referencias: e.target.value})} placeholder="Ej: Casa azul, frente al parque" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Seccion Electoral</label>
                    <select value={formEditarPromovido.seccion_id || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, seccion_id: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="">Seleccionar...</option>
                      {catalogosMiembros?.secciones?.map(s => <option key={s.id} value={s.id}>{s.numero_seccion} - {s.municipio}</option>)}
                    </select></div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Ubicacion GPS</label>
                    <div className="flex gap-2">
                      <input value={formEditarPromovido.latitud || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, latitud: e.target.value})} placeholder="Latitud" className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"/>
                      <input value={formEditarPromovido.longitud || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, longitud: e.target.value})} placeholder="Longitud" className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"/>
                      <button type="button" onClick={() => { if(navigator.geolocation) navigator.geolocation.getCurrentPosition(pos => setFormEditarPromovido({...formEditarPromovido, latitud: pos.coords.latitude.toString(), longitud: pos.coords.longitude.toString()})); }}
                        className="px-3 py-2 bg-green-600 text-white rounded-lg text-xs hover:bg-green-700">📍</button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <p className="text-sm font-semibold mb-3" style={{color:'#14532d'}}>3. Perfil Politico</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Estructura</label>
                    <select value={formEditarPromovido.estructura_id || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, estructura_id: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="">Seleccionar...</option>
                      {estructuras.map(e => <option key={e.id} value={e.id}>{e.nombre_estructura}</option>)}
                    </select></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Resultado de Visita</label>
                    <select value={formEditarPromovido.resultado_visita || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, resultado_visita: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="">Seleccionar...</option>
                      <option value="contactado">Contactado</option>
                      <option value="no_contactado">No Contactado</option>
                      <option value="rechazo">Rechazo</option>
                      <option value="sin_respuesta">Sin Respuesta</option>
                    </select></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Nivel de Apoyo</label>
                    <select value={formEditarPromovido.nivel_apoyo || 'simpatizante'} onChange={e => setFormEditarPromovido({...formEditarPromovido, nivel_apoyo: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="simpatizante">Simpatizante</option>
                      <option value="seguro">Seguro</option>
                      <option value="defensa_del_voto">Defensa del Voto</option>
                      <option value="indeciso">Indeciso</option>
                      <option value="oposicion">Oposicion</option>
                      <option value="no_definido">No definido</option>
                    </select></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Ocupacion</label>
                    <select value={formEditarPromovido.ocupacion_general || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, ocupacion_general: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="">Seleccionar...</option>
                      {['comerciante','docente','profesionista','ama_de_casa','campesino','servidor_publico','empleado_privado','empresario','desempleado','estudiante','otro'].map(o => <option key={o} value={o}>{o.replace(/_/g,' ')}</option>)}
                    </select></div>
                </div>
              </div>
              <div>
                <p className="text-sm font-semibold mb-3" style={{color:'#14532d'}}>4. Banco de Talento</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Disponibilidad de Servir</label>
                    <select value={formEditarPromovido.disponibilidad_servir || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, disponibilidad_servir: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="">Seleccionar...</option>
                      <option value="si">Si</option>
                      <option value="no">No</option>
                      <option value="tal_vez">Tal vez</option>
                    </select></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Participacion</label>
                    <select value={formEditarPromovido.tipo_participacion_interes || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, tipo_participacion_interes: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="">Seleccionar...</option>
                      {tiposParticipacion.filter(t => t.activo).map(t => <option key={t.id} value={t.clave}>{t.nombre}</option>)}
                    </select></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Area de Interes</label>
                    <select value={formEditarPromovido.area_interes || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, area_interes: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="">Seleccionar...</option>
                      {['educacion','salud','seguridad','deporte','cultura','desarrollo_social','administracion','comunicacion','campo','obras_servicios','turismo','juventud','otra'].map(a => <option key={a} value={a}>{a.replace(/_/g,' ')}</option>)}
                    </select></div>
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Nivel de Estudios</label>
                    <select value={formEditarPromovido.nivel_estudios || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, nivel_estudios: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                      <option value="">Seleccionar...</option>
                      {['primaria','secundaria','preparatoria','tecnico','licenciatura','posgrado','sin_estudios'].map(n => <option key={n} value={n}>{n.replace(/_/g,' ')}</option>)}
                    </select></div>
                  <div className="flex items-center gap-3 md:col-span-2">
                    <input type="checkbox" id="talento_edit" checked={formEditarPromovido.es_talento_potencial || false} onChange={e => setFormEditarPromovido({...formEditarPromovido, es_talento_potencial: e.target.checked})} className="w-4 h-4 rounded"/>
                    <label htmlFor="talento_edit" className="text-sm font-medium text-gray-700">Marcar como talento potencial</label>
                  </div>
                </div>
              </div>
              <div>
                <p className="text-sm font-semibold mb-3" style={{color:'#14532d'}}>5. Programas Sociales</p>
                <div className="flex items-center gap-3 mb-3">
                  <input type="checkbox" id="beneficiario_edit" checked={formEditarPromovido.es_beneficiario_programa || false} onChange={e => setFormEditarPromovido({...formEditarPromovido, es_beneficiario_programa: e.target.checked})} className="w-4 h-4 rounded"/>
                  <label htmlFor="beneficiario_edit" className="text-sm font-medium text-gray-700">Es beneficiario de algun programa social?</label>
                </div>
                {formEditarPromovido.es_beneficiario_programa && (
                  <div className="grid grid-cols-2 gap-2">
                    {programas.filter(p => p.activo).map(prog => (
                      <label key={prog.clave} className="flex items-center gap-2 text-sm">
                        <input type="checkbox"
                          checked={(formEditarPromovido.programas_sociales || []).includes(prog.clave)}
                          onChange={e => {
                            const current = formEditarPromovido.programas_sociales || [];
                            const updated = e.target.checked ? [...current, prog.clave] : current.filter(c => c !== prog.clave);
                            setFormEditarPromovido({...formEditarPromovido, programas_sociales: updated});
                          }}
                          className="w-4 h-4 rounded"/>
                        {prog.etiqueta}
                      </label>
                    ))}
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Observaciones</label>
                <textarea value={formEditarPromovido.observaciones || ''} onChange={e => setFormEditarPromovido({...formEditarPromovido, observaciones: e.target.value})}
                  rows={3} placeholder="Notas sobre esta persona..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
              </div>
              <div className="flex gap-3 pt-2">
                <button type="button" onClick={() => setMostrarModalEditarPromovido(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50">Cancelar</button>
                <button type="submit" className="flex-1 text-white font-semibold py-2 rounded-lg hover:opacity-90"
                  style={{ background:'linear-gradient(135deg,#16a34a,#9b1c35)' }}>Guardar Cambios</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* ── MODAL PROMOVER ── */}
      {mostrarModalPromover && promovidoAPromover && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
            <div className="p-5 text-white rounded-t-2xl flex justify-between items-center sticky top-0" style={{ background:'linear-gradient(135deg,#7c3aed,#5c1022)' }}>
              <h3 className="font-bold text-lg">⬆️ Promover a Rol del Sistema</h3>
              <button onClick={() => setMostrarModalPromover(false)} className="hover:bg-white hover:bg-opacity-20 p-1 rounded"><X size={20}/></button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-gray-600 text-sm">Promovido: <strong>{promovidoAPromover.nombre} {promovidoAPromover.apellido_paterno}</strong></p>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Rol *</label>
                <select value={rolSeleccionado} onChange={e => setRolSeleccionado(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500">
                  <option value="">Seleccionar...</option>
                  {roles.map(r => <option key={r.id} value={r.id}>{r.nombre.replace(/_/g,' ')}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Estructura</label>
                <select value={estructuraPromover} onChange={e => setEstructuraPromover(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500">
                  <option value="">Sin estructura asignada</option>
                  {estructuras.map(e => <option key={e.id} value={e.id}>{e.nombre_estructura}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Líder Inmediato</label>
                <select value={liderPromover} onChange={e => setLiderPromover(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500">
                  <option value="">Sin líder asignado</option>
                  {catalogosMiembros.miembros_para_lider?.map(m => <option key={m.id} value={m.id}>{m.nombre} {m.apellido_paterno} — {m.nombre_cargo||m.rol_nombre}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sección Electoral</label>
                <select value={seccionPromover} onChange={e => setSeccionPromover(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500">
                  <option value="">Seleccionar...</option>
                  {catalogosMiembros.secciones?.map(s => <option key={s.id} value={s.id}>{s.numero_seccion} - {s.municipio}</option>)}
                </select>
              </div>
              {resultadoPromover && (
                <div className={`p-3 rounded-lg text-sm ${resultadoPromover.exito?'bg-green-50 text-green-800':'bg-red-50 text-red-800'}`}>
                  {resultadoPromover.mensaje}
                </div>
              )}
              <div className="flex gap-3 pt-2">
                <button onClick={() => setMostrarModalPromover(false)} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-600 text-sm hover:bg-gray-50">Cancelar</button>
                <button onClick={handlePromoverRol} disabled={promoviendoRol}
                  className="flex-1 text-white text-sm font-semibold py-2 rounded-lg hover:opacity-90 disabled:opacity-50"
                  style={{ background:'linear-gradient(135deg,#7c3aed,#5c1022)' }}>
                  {promoviendoRol ? 'Procesando...' : '⬆️ Promover'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── MODAL EDITAR MIEMBRO ── */}
      {mostrarModalEditarMiembro && miembroEditando && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="p-5 text-white rounded-t-2xl flex justify-between items-center" style={{ background:'linear-gradient(135deg,#14532d,#5c1022)' }}>
              <h3 className="font-bold text-lg">✏️ Editar Miembro</h3>
              <button onClick={() => setMostrarModalEditarMiembro(false)} className="hover:bg-white hover:bg-opacity-20 p-1 rounded"><X size={20}/></button>
            </div>
            <form onSubmit={handleGuardarMiembro} className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Estructura</label>
                <select value={formEditarMiembro.estructura_id} onChange={e => setFormEditarMiembro({...formEditarMiembro,estructura_id:e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                  <option value="">Sin estructura</option>
                  {catalogosMiembros.estructuras?.map(e => <option key={e.id} value={e.id}>{e.nombre_estructura}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Cargo</label>
                <select value={formEditarMiembro.cargo_id} onChange={e => setFormEditarMiembro({...formEditarMiembro,cargo_id:e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                  <option value="">Sin cargo</option>
                  {catalogosMiembros.cargos?.map(c => <option key={c.id} value={c.id}>{c.nombre_cargo}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sección Electoral</label>
                <select value={formEditarMiembro.seccion_id} onChange={e => setFormEditarMiembro({...formEditarMiembro,seccion_id:e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                  <option value="">Seleccionar...</option>
                  {catalogosMiembros.secciones?.map(s => <option key={s.id} value={s.id}>{s.numero_seccion} - {s.municipio}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Líder Inmediato</label>
                <select value={formEditarMiembro.lider_inmediato_id} onChange={e => setFormEditarMiembro({...formEditarMiembro,lider_inmediato_id:e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                  <option value="">Sin líder</option>
                  {catalogosMiembros.miembros_para_lider?.filter(m => m.id !== miembroEditando?.id).map(m => <option key={m.id} value={m.id}>{m.nombre} {m.apellido_paterno} — {m.nombre_cargo||m.rol_nombre}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fecha Inicio</label>
                <input type="date" value={formEditarMiembro.fecha_inicio} onChange={e => setFormEditarMiembro({...formEditarMiembro,fecha_inicio:e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Observaciones</label>
                <input value={formEditarMiembro.observaciones} onChange={e => setFormEditarMiembro({...formEditarMiembro,observaciones:e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"/>
              </div>
              <div className="md:col-span-2 flex gap-3">
                <button type="button" onClick={() => setMostrarModalEditarMiembro(false)} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50">Cancelar</button>
                <button type="submit" className="flex-1 text-white font-semibold py-2 rounded-lg hover:opacity-90" style={{ background:'linear-gradient(135deg,#16a34a,#9b1c35)' }}>Guardar Cambios</button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}
